// see https://emoji-button.js.org/docs/api#categories
// for valid categories
export default function getEmojiCategories() {
  return ['smileys', 'people', 'animals', 'food', 'activities', 'travel', 'objects', 'symbols', 'flags'];
}
